import * as React from 'react';

interface ConfigContextProps {
  bugsnagApiKey?: string;
}

interface ConfigProviderProps {
  bugsnagApiKey?: string;
  children: React.ReactNode;
}

const BugsnagConfigContext = React.createContext<ConfigContextProps | undefined>(undefined);

export const useBugsnagConfig = () => {
  const context = React.useContext(BugsnagConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

const BugsnagConfigProvider: React.FC<ConfigProviderProps> = ({ bugsnagApiKey, children }) => {
  return (
    <BugsnagConfigContext.Provider value={{ bugsnagApiKey }}>
      {children}
    </BugsnagConfigContext.Provider>
  );
};

export default BugsnagConfigProvider;